module.exports = "<p>\n  widget-images-banner-three works!\n</p>\n"